import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VvsGotchiState } from 'state/types'
import { Acceptance, Onboarding, AccessToken } from './models'

const initialState: VvsGotchiState = {
  acceptance: {},
  onboarding: {},
  accessToken: {},
  bgmPlay: true,
  sePlay: true,
}

const vvsGotchiSlice = createSlice({
  name: 'vvsgotchi',
  initialState,
  reducers: {
    setAcceptance: (state, action: PayloadAction<{ address: string; acceptance: Acceptance }>) => {
      const { address, acceptance } = action.payload
      state.acceptance[address] = acceptance
    },
    setOnboarding: (state, action: PayloadAction<{ address: string; onboarding: Onboarding }>) => {
      if (!state.onboarding) {
        state.onboarding = {}
      }
      state.onboarding[action.payload.address] = action.payload.onboarding
    },
    setAccessToken: (state, action: PayloadAction<{ address: string; accessToken: AccessToken }>) => {
      state.accessToken[action.payload.address] = action.payload.accessToken
    },
    muteBgm: (state) => {
      state.bgmPlay = false
    },
    unmuteBgm: (state) => {
      state.bgmPlay = true
    },
    muteSe: (state) => {
      state.sePlay = false
    },
    unmuteSe: (state) => {
      state.sePlay = true
    },
  },
})

export const { setAcceptance, setOnboarding, setAccessToken, muteBgm, muteSe, unmuteBgm, unmuteSe } =
  vvsGotchiSlice.actions

export default vvsGotchiSlice.reducer
